module.exports = __webpack_public_path__ + "img/defaultImg.c1a2e1ed.png";